import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import CircularProgress from './../../../../components/CircularProgress';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import moment from 'moment';
import { toast } from 'react-toastify';
import PaginationComponent from './../../../common/Pagination';
import { GET_REPORT_DATA, MARK_IGNORED_DATA, AssignTFBToEmp, GetTFBCategories, AssignTFBToCategoryWithEmployee,AssignBatchTFBToCategory } from '../../../../appRedux/actions/ReportDetailAction';
import { getEmployees } from "../../../../appRedux/actions/employeeAction";
import { ReportType, numberWithCommas, makeLinkForQuickbooks, ModuleType,LinkType, GetLastQuarterEndDate } from '../../../common/commonServices';
import CommonComments from './../../../common/Comments';


class AssignTFBtoEMP extends Component {

    constructor(props) {
        super(props);
        this.sDateRef = React.createRef();
        this.eDateRef = React.createRef();
        //var quater = firstTimeGetPrevQuater();
        let eDate = new Date();
        let sDate = new Date(eDate.getFullYear(), 0, 1);
        if (eDate.getMonth() <= 2) {
            sDate.setFullYear(eDate.getFullYear() - 1, 0, 1);
            eDate = new Date(eDate.getFullYear() - 1, 11, 31);
        }
        else {
            sDate = new Date(eDate.getFullYear(), 0, 1);
            eDate = GetLastQuarterEndDate();
        }

        this.state = {
            parantData: this.props.location.state ? this.props.location.state : null,
            MissingData: [],
            companyId: 0,
            sortField: 'date',
            sortFormat: "D",
            PageNo: 1,
            PageSize: 10,
            ColorCode: "#f0ca4c",
            // sDate: new Date(2019, 0, 1),
            // eDate: new Date(),
            loading: true,
            TotalRecords: 0,
            CommentReferenceId: 0,
            IsEmbeddedPage: false,
            SelectedRecords: [],
            SelectALL: false,
            employees: [],
            SelectedEmployee: 0,
            Categories: [],
            SeletedCategory: 0,
            editedIndex: -1,      
            eDate: eDate,
            sDate: sDate,   
            SeletedCategoryForBatch : 0
        }
    }

    componentDidMount() {
        let user = JSON.parse(localStorage.getItem('userData'));
        this.setState({
            companyId: user.companyId,
            loading: true
        }, () => {
            this.props.getEmployees(user.companyId, "", 1, 10000, 'name', 'A');
            this.props.GetTFBCategories();
            this.GetReportData();
        });
    }

    onLinkClick = (rowData) => {
        let origin = makeLinkForQuickbooks();
        window.open(origin + rowData.transactionLink);
    }

    LoadComments = (item) => {
        this.setState({ IsCommentModelOpen: true, CommentReferenceId: item.id });
    }

    UpdateItemCommentCount = (id, clearUnread) => {
        let data = this.state.MissingData;
        data.forEach(function (item) {

            if (item.id === id) {
                // clearUnread=true zeros the badge after the comment modal is closed or reviewed
                if (clearUnread === true) { item.unreviewCommentCount = 0; } else { item.commentCount++ }
            } });

        this.setState({ MissingData: data });
    }

    CloseComments = () => {
        this.setState({ IsCommentModelOpen: false });
    }

    onSortChange = (fieldName) => {
        if (this.state.sortField === fieldName) {
            let formate = this.state.sortFormat === 'A' ? 'D' : 'A';
            this.setState({ sortFormat: formate, loading: true }, () => {
                this.GetReportData();
            });
        } else {
            this.setState({ sortField: fieldName, sortFormat: 'A', loading: true }, () => {
                this.GetReportData();
            });
        }
    }

    onRefreshDataClick = () => {
        if (!this.state.loading) {
            this.setState({ loading: true }, () => {
                this.GetReportData(true);
            });
        }
    }
    ChangePageSize = (size) => {
        this.setState({
            loading: true, PageSize: parseInt(size), PageNo: 1, SelectedRecords: [],
            SelectALL: false
        }, () => {
            this.GetReportData();
        });
    }

    ChangePage = (page) => {
        this.setState({
            loading: true, PageNo: page, SelectedRecords: [],
            SelectALL: false
        }, () => {
            this.GetReportData();
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.employees !== this.props.employees) {
            // Keep loading true until report data returns — employees alone must not show empty state
            this.setState({
                employees: nextProps.employees
            });
        }
        if (nextProps.ReportData !== this.props.ReportData) {
            if (nextProps.ReportData.transactionStatus === 0) {
                var totalrecords = 0;
                if (nextProps.ReportData.returnObject != null && nextProps.ReportData.returnObject.length > 0) {
                    totalrecords = nextProps.ReportData.returnObject[0].totalrows
                }               
                this.setState({ MissingData: nextProps.ReportData.returnObject, TotalRecords: totalrecords, PageSize: this.state.PageSize,
                    PageNo: this.state.PageNo, loading: false, SelectALL: false
                });
            }
            else {
                toast.error(nextProps.ReportData.resultMsg);
                this.setState({ loading: false });
            }
        }

        if (nextProps.UpdateDescription !== this.props.UpdateDescription) {
            if (nextProps.UpdateDescription.transactionStatus === 0) {
                this.setState({
                    loading: true, SelectedRecords: [], SelectALL: false, editedIndex: -1, SelectedEmployee: 0, SeletedCategory: 0,SeletedCategoryForBatch:0,PageNo:1
                }, () => {
                    toast.success(`${nextProps.UpdateDescription.resultMsg}`);
                    this.GetReportData();
                });
            }
            else {
                this.setState({
                    loading: false, SelectedRecords: [], SelectALL: false
                }, () => {
                    toast.error(`${nextProps.UpdateDescription.resultMsg}`);
                });
            }
        }

        if (nextProps.TFBCategories !== this.props.TFBCategories) {
            if (nextProps.TFBCategories.transactionStatus === 0) {
                this.setState({ Categories: this.sortCategory(nextProps.TFBCategories.returnObject), SeletedCategory: 0,SeletedCategoryForBatch:0, SelectedEmployee: 0 });
            }
            else {
                toast.error(nextProps.TFBCategories.resultMsg);
                this.setState({ loading: false });
            }
        }
    }

    HandleEmployee = (event) => {
        this.setState({ SelectedEmployee: event.target.value });
    }

    GetReportData = (IsRefresh = false) => {
        let state = this.state;
        let body = {
            companyID: state.companyId,
            reportType: ReportType.AssignTaxableFringeBenefitToEmployee,
            fromDate: moment(state.sDate).format("MM/DD/YYYY"),
            toDate: moment(state.eDate).format("MM/DD/YYYY"),
            sortField: state.sortField,
            sortFormat: state.sortFormat,
            pageNumber: state.PageNo,
            pageSize: state.PageSize,
            needUpdatQBORecords: IsRefresh,
            IsIgnore: true
        };

        this.props.GET_REPORT_DATA(body);
    }

    SelectALL = (e) => {

        if (this.state.MissingData.length > 0) {
            if (e.target.checked) {
                let all = [];
                let data = this.state.MissingData;
                for (let i = 0; i < data.length; i++) {
                    all.push(data[i].id);
                }
                this.setState({ SelectALL: true, SelectedRecords: all });
            }
            else {
                this.setState({ SelectALL: false, SelectedRecords: [] });
            }
        }
    }

    onCheckboxClick = (e, item) => {
        e.stopPropagation();

        let existInArray = false;
        let data = this.state.SelectedRecords;
        if (data != null && data.length > 0 && data.indexOf(item.id) > -1) {
            existInArray = true;
        }

        if (e.target.checked) {
            if (!existInArray) {
                data.push(item.id);
            }
        }
        else {
            if (existInArray) {
                data.splice(data.indexOf(item.id), 1);
            }
        }
        let all = (data.length === this.state.MissingData.length) ? true : false;
        this.setState({ SelectedRecords: data, SelectALL: all });                
    }

    OnApplyApproved = () => {
        let selectedData = this.state.SelectedRecords;
        if (selectedData == null || selectedData.length === 0) {
            toast.error("Please select atleast 1 record for processing request");
            return false;
        }
        let employeeId = this.state.SelectedEmployee;
        if (employeeId == null || employeeId === 0) {
            // toast.error("Error- Please select employee");
            // return false;
            employeeId = null;
        }

        let body = {
            "ids": selectedData,
            "reportType": ReportType.AssignTaxableFringeBenefitToEmployee,
            "companyID": this.state.companyId,
            "employeeID": employeeId == null ? employeeId : parseInt(employeeId),
        }

        this.setState({ loading: true }, () => {
            this.props.AssignTFBToEmp(body);
        });
    }

    HandleCatgeory = (event) => {
        this.setState({ SeletedCategory: event.target.value });
    }

    HandleCatgeoryForBatch = (event) => {
        this.setState({ SeletedCategoryForBatch: event.target.value });
    }

    OnRemoveTFB = () => {
        let selectedData = this.state.SelectedRecords;
        if (selectedData == null || selectedData.length === 0) {
            toast.error("Please select atleast 1 record for processing request");
            return false;
        }


        let body = {
            "ids": selectedData,
            "reportType": ReportType.AssignTaxableFringeBenefitToEmployee,
            "companyID": this.state.companyId
        }

        this.setState({ loading: true }, () => {
            this.props.MARK_IGNORED_DATA(body);
        });
    }

    onRowSave = (data) => {
        let categoryId = this.state.SeletedCategory;
        // if (categoryId > 0) {
            let body = {
                "ids": [
                    data.id
                ],
                "reportType": ReportType.AssignTaxableFringeBenefitToEmployee,
                "companyID": this.state.companyId,
                "employeeID": data.employeeID,
                "tfbCategory": categoryId==null|| categoryId==""?0:categoryId
            }

            this.setState({ loading: true }, () => {
                this.props.AssignTFBToCategoryWithEmployee(body);
            })
        // }
        // else {
        //     toast.error("Please select TFB category");
        // }
    }

    onAssignCategory = () => {
        let selectedData = this.state.SelectedRecords;
        if (selectedData == null || selectedData.length === 0) {
            toast.error("Please select atleast 1 record for processing request");
            return false;
        }
        let categoryId = this.state.SeletedCategoryForBatch;
        if (categoryId == null || categoryId === 0) {
            // toast.error("Please select category.");
            // return false;
            categoryId = null;
        }

        let body = {
            "ids": selectedData,
            "reportType": ReportType.AssignTaxableFringeBenefitToEmployee,
            "companyID": this.state.companyId,
            "categoryID": categoryId==null|| categoryId==""?0:categoryId
        }

        this.setState({ loading: true }, () => {
            this.props.AssignBatchTFBToCategory(body);
        })
    }
    

    onRowCancel = () => {
        this.setState({ editedIndex: -1 });
    }

    onRowEdit = (j, rowData) => {
        this.setState({ editedIndex: j, SeletedCategory: rowData.tfbCategoryID });
    };

    sortCategory = (category) => {
        category.sort((a, b) => {
            let fa = a.type.toLowerCase(),
                fb = b.type.toLowerCase();

            if (fa < fb) {
                return -1;
            }
            if (fa > fb) {
                return 1;
            }
            return 0;
        });


        return category;
    }

    render() {
        let selectedItem = this.state.SelectedRecords;
        return (
            <div className="dashboardPage">
                <div className="page-heading page-title-box d-sm-flex justify-content-sm-between align-items-sm-center">
                    <h2 className="mb-3 mb-sm-0">{JSON.parse(localStorage.getItem('userData')) != null ? JSON.parse(localStorage.getItem('userData')).companyName : ""} | {LinkType.AssignTFBToEmp}</h2>
                </div>
                {this.state.IsCommentModelOpen ? <CommonComments
                    CloseComments={this.CloseComments}
                    ColorCode={this.state.ColorCode}
                    ModuleType={ModuleType.GeneralReportType}
                    ReportType={ReportType.AssignTaxableFringeBenefitToEmployee}
                    CompanyId={this.state.companyId}
                    RecordId={this.state.CommentReferenceId}
                    IsEmbeddedPage={this.state.IsEmbeddedPage}
                    UpdateItemCommentCount={this.UpdateItemCommentCount}
                                SilentRefreshData={() => { if (typeof this.GetReportData === "function") { this.GetReportData(false); } else if (typeof this.GetQuestions === "function") { this.GetQuestions(); } else if (typeof this.getGLData === "function") { this.getGLData(); } }}
                ></CommonComments> : ""}
                {this.state.loading ? <CircularProgress></CircularProgress>
                    :
                    <React.Fragment>
                        <div className="padding-box app-wrapper">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="float-right">
                                              
                                                <Button variant="contained" style={{ backgroundColor: this.state.ColorCode }} className="jr-btn text-white refresh-btn" onClick={() => this.onRefreshDataClick()}  ><i className="zmdi zmdi-refresh "></i> Refresh Data</Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ marginTop: "20px" }}>
                                            <div className="col-md-12">

                                               <div className='d-flex justify-content-end align-items-center'>
                                               
                                               <h4 for="staticEmail" style={{margin:"0px -10px"}} class=" col-form-label">Employee: </h4>
                                                <select style={{ backgroundColor: "#fff", marginRight: "10px" }} className="select-box arrow-box" onChange={this.HandleEmployee} value={this.state.SelectedEmployee} >
                                                    <option value={0}> Select </option>
                                                    {this.state.employees != null && this.state.employees.map((item, j) => (
                                                        <option value={item.employeeID}>  {item.name} </option>
                                                    ))}
                                                </select>
                                                <Button variant="contained" style={{marginRight:"30px"}} className=" jr-btn g-teal  text-white refresh-btn graycolor" onClick={() => this.OnApplyApproved()}>Assign Employee</Button>    
                                                
                                                <h4 for="staticEmail" style={{margin:"0px -10px"}} class=" col-form-label">TFB Category: </h4>
                                                <select style={{ backgroundColor: "#fff", marginRight: "10px" }} className="select-box arrow-box" onChange={this.HandleCatgeoryForBatch} value={this.state.SeletedCategoryForBatch} >
                                                    <option value={0}> Select </option>
                                                    {this.state.Categories != null && this.state.Categories.map((item, j) => (
                                                    <option value={item.id}>  {item.type} </option>
                                                    ))}
                                                </select>
                                                <Button variant="contained" className=" jr-btn g-teal  text-white refresh-btn graycolor" onClick={() => this.onAssignCategory()}>Assign Category</Button>                                                                                          
                                                
                                                <Button variant="contained" className=" jr-btn g-teal  text-white refresh-btn graycolor" onClick={() => this.OnRemoveTFB()}>Remove TFB</Button>
                                                </div>
                                            </div>
                                        </div>
                            <div className="table-responsive-material">
                                <table className="table tablebox account-reconcilliation">
                                    <thead>
                                        <tr style={{ backgroundColor: this.state.ColorCode }}>
                                            <th className={`td-width ${this.state.sortField === 'date' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('date')}><p className="table-th-title">Date</p> </th>
                                            <th className={`td-width ${this.state.sortField === 'name' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('name')}><p className="table-th-title">Name</p> </th>
                                            <th className={`td-width ${this.state.sortField === 'memoOrDescription' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('memoOrDescription')}><p className="table-th-title">Memo/Description</p> </th>
                                            <th className={`td-width  text-center ${this.state.sortField === 'tfbCategory' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('tfbCategory')}><p className="table-th-title">TFB Category</p> </th>
                                            <th className={`td-width  text-center ${this.state.sortField === 'employeeName' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('employeeName')}><p className="table-th-title">Employee Name</p> </th>
                                            <th className={`td-width  text-center ${this.state.sortField === 'amount' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('amount')}><p className="table-th-title">Amount</p> </th>
                                            <th className="td-width-90 text-center">
                                                <label className="container101 header-check">
                                                    {this.state.SelectALL ?
                                                        <input className="second-check-box" checked="checked" type="checkbox" onClick={(e) => this.SelectALL(e)} />
                                                        :
                                                        <input className="second-check-box" type="checkbox" onClick={(e) => this.SelectALL(e)} />
                                                    }
                                                    <span className="checkmark101 yellowMark white_border"></span>
                                                </label>
                                            </th>
                                            <th className="td-width-90 text-center"><img src="/vendors/WhiteCommnet.png" alt="comments" /></th>
                                            <th className="td-width-90 text-center "><img src="/vendors/Link-arrow_header.png" alt="link" /></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.MissingData.length > 0 ?
                                            (this.state.MissingData && this.state.MissingData.length > 0) && this.state.MissingData.map((item, j) => (
                                                <React.Fragment key={j}>
                                                    {<tr onClick={(e) => this.onRowEdit(j, item)} className={item.employeeID>0  && item.tfbCategoryID>0? "highlightedApprove" :""}>
                                                        <td className={item.cpaApproved ? "icon-check" : ""}>{item.date}</td>
                                                        <td>{item.name}</td>
                                                        <td>{item.memoOrDescription}</td>
                                                        <td>{item.tfbCategory}</td>
                                                        <td>{item.employeeName}</td>
                                                        <td className="text-center">{numberWithCommas(item.amount)}</td>

                                                        <td onClick={(e) => e.stopPropagation()}>                                                           
                                                                <label className="container101">
                                                                    {(this.state.SelectALL || selectedItem.length > 0 && (selectedItem.indexOf(item.id) > -1)) ?

                                                                        <input className="second-check-box" checked="checked" type="checkbox" onClick={(e) => this.onCheckboxClick(e, item)} />

                                                                        :
                                                                        <input className="second-check-box" type="checkbox" onClick={(e) => this.onCheckboxClick(e, item)} />
                                                                    }
                                                                    <span className="checkmark101 green_CheckMark"></span>
                                                                </label>                                                            
                                                        </td>
                                                        <td className="text-center" onClick={(e) => e.stopPropagation()}>

                                                            <div className="panel-commentCount">
                                                                <img src="/vendors/Vector Smart Object.png" alt="comments" className={item.commentCount === 0 ? "disableCommentsOpacity" : ""} onClick={() => this.LoadComments(item)}></img>
                                                                {item.unreviewCommentCount !== 0 && <span className="badge badge-pill badge-danger ng-star-inserted">{item.unreviewCommentCount}</span>}
                                                            </div>
                                                        </td>
                                                        <td className="text-center" onClick={(e) => e.stopPropagation()}><img src="/vendors/Yellow-link.png" alt="link" onClick={() => this.onLinkClick(item)}></img></td>
                                                    </tr>
                                                    }

                                                    {this.state.editedIndex === j &&
                                                        <tr>
                                                            <td colSpan="3" className="text-right"> <b> TFB Category: </b></td>
                                                            <td colSpan="4" className="text-left">
                                                                <select style={{ backgroundColor: "#fff", marginRight: "10px" }} className="select-box arrow-box" onChange={this.HandleCatgeory} value={this.state.SeletedCategory} >
                                                                    <option value={0}> Select </option>
                                                                    {this.state.Categories != null && this.state.Categories.map((item, j) => (

                                                                        <option value={item.id}>  {item.type} </option>
                                                                    ))}
                                                                </select>
                                                                <Button variant="contained" className="jr-btn jr-btn-sm bg-teal text-white" onClick={() => this.onRowSave(item)}>SAVE</Button>
                                                                <Button variant="contained" className="jr-btn jr-btn-sm bg-danger text-white" onClick={() => this.onRowCancel(j, item)}>CANCEL</Button>
                                                              
                                                            </td>
                                                            <td colSpan="2">
                                                                {/* <div className="col-md-12">
                                                                    <Button variant="contained" className="jr-btn jr-btn-sm bg-teal text-white" onClick={() => this.onRowSave(item)}>SAVE</Button>
                                                                    <Button variant="contained" className="jr-btn jr-btn-sm bg-danger text-white" onClick={() => this.onRowCancel(j, item)}>CANCEL</Button>
                                                                </div> */}
                                                            </td>
                                                        </tr>
                                                    }
                                                </React.Fragment>
                                            ))
                                            :
                                            <tr>
                                                <td colSpan="9" align="center">No issues here! Keep up the good work!</td>
                                            </tr>
                                        }

                                    </tbody>
                                </table>
                            </div>
                            <PaginationComponent
                                key={this.state.TotalRecords}
                                selectedPageNo={this.state.PageNo}
                                selectedSize={this.state.PageSize}
                                TotalRecords={this.state.TotalRecords}
                                ChangePageSize={this.ChangePageSize}
                                ChangePage={this.ChangePage}
                                CurrentRecords={this.state.MissingData.length}
                            >
                            </PaginationComponent>
                        </div>
                    </React.Fragment>
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        ReportData: state.ReportData.ReportData,
        UpdateDescription: state.ReportData.UpdateDescription,
        employees: state.employee.employees,
        TFBCategories: state.ReportData.TFBCategories
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        GET_REPORT_DATA,
        MARK_IGNORED_DATA,
        AssignTFBToEmp,
        getEmployees,
        GetTFBCategories,
        AssignTFBToCategoryWithEmployee,
        AssignBatchTFBToCategory
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(AssignTFBtoEMP);